import { notification } from "antd";
import { useCallback, useState } from "react";
import { useLanguage } from "~/hooks/useLanguage";
import { sendPasswordResetEmail } from "../services/sendPasswordResetEmail";
import { ForgotPasswordError } from "../constant/error";

export const useSendPasswordResetEmail = () => {
  const { formatMessage } = useLanguage();
  const [loading, setLoading] = useState(false);

  const onExecute = useCallback(
    async (email: string) => {
      setLoading(true);

      try {
        const response = await sendPasswordResetEmail(email);

        if (
          response.succeed &&
          response.messageCode === "ResetPasswordRequestTaken" //"ResetPasswordRequestTaken" means operation is successful
        ) {
          notification.success({
            message: formatMessage("ForgotPassword.Success.Message"),
            description: formatMessage("ForgotPassword.Success.Description"),
          });
        }
      } catch (error) {
        const forgotPasswordError =
          ForgotPasswordError[(error as Error)?.message as string];
        if (forgotPasswordError) {
          notification.error({
            message: formatMessage(forgotPasswordError.message),
            description: forgotPasswordError?.description
              ? formatMessage(forgotPasswordError?.description)
              : undefined,
          });
        } else {
          notification.error({
            message: (error as Error)?.message,
          });
        }
        return [];
      } finally {
        setLoading(false);
      }
    },
    [formatMessage],
  );
  return {
    sendPasswordResetEmail: onExecute,
    loading,
  };
};
